import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  noPadding?: boolean;
  borderColor?: 'red' | 'yellow' | 'green' | 'orange' | 'navy' | 'none';
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className,
  children,
  noPadding = false,
  borderColor = 'none',
  ...props
}, ref) => {
  const borderColors = {
    red: 'border-l-4 border-l-brand-red',
    yellow: 'border-l-4 border-l-brand-yellow',
    green: 'border-l-4 border-l-brand-green',
    orange: 'border-l-4 border-l-brand-orange',
    navy: 'border-l-4 border-l-brand-navy',
    none: ''
  };
  return <motion.div ref={ref} className={cn('bg-brand-offwhite rounded-2xl shadow-lg border border-brand-wood/10 overflow-hidden', borderColors[borderColor], noPadding ? '' : 'p-6 md:p-8', className)} {...props} data-id="element-669">
        {children}
      </motion.div>;
});
Card.displayName = 'Card';